export const Sales = {
    ClueMarketingLandingPage: '落地頁註冊',
    NoTimeRangePermissionTip: '該帳戶暫無可查詢時段的數據權限，請聯繫客戶管理團隊添加',
    SelectTimeRangeTip: '請選擇查詢時間範圍',
};
